// removed by extract-text-webpack-plugin
module.exports = {"button":"SearchButton__button___qVFIk"};